import styled from 'styled-components';
import { Typography } from 'components/core';

const BigBoldNumber = styled(Typography)`
  font-size: 45px;
`;

export const Styled = {
  BigBoldNumber,
};
